import { render, staticRenderFns } from "./BulkUpdateCountryOfOrigin.vue?vue&type=template&id=e9120786&scoped=true&"
import script from "./BulkUpdateCountryOfOrigin.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateCountryOfOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9120786",
  null
  
)

export default component.exports